import { render, staticRenderFns } from "./AiChatDetails.vue?vue&type=template&id=4a94a026&scoped=true&"
import script from "./AiChatDetails.vue?vue&type=script&lang=js&"
export * from "./AiChatDetails.vue?vue&type=script&lang=js&"
import style0 from "./AiChatDetails.vue?vue&type=style&index=0&id=4a94a026&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a94a026",
  null
  
)

export default component.exports